import * as React from 'react';
import GlobalHeader from './components/GlobalHeader';
import { IUserColumns } from './Entities/User/User';
import { Dispatch } from 'redux';
import { Action } from 'redux-actions';
import { UserSelector } from './Entities/User/User.Selector';
import { connect } from 'react-redux';
import { Switch, Route, withRouter } from 'react-router-dom';
import CoursePortalMain from './Pages/CoursePortal';
import { RouteHelper } from './helpers/RouteHelper';
import { AuthHelper } from './helpers/AuthHelper';
import { ModalContainer } from './shared/Modal';
import MyPagePanelContainer from './components/MyPagePanel/Container';

interface IAppProps {
  User: IUserColumns;
  logOut: () => void;
}

class App extends React.Component<IAppProps, any> {
  constructor(props: any) {
    super(props);
    this.signOff = this.signOff.bind(this);
  }

  public signOff() {
    this.props.logOut();
  }

  public render() {
    return (
      <>
        <MyPagePanelContainer />
        <GlobalHeader
          menuItems={RouteHelper.Instance.getMenuItemsForUser(this.props.User)}
          userName={this.props.User.name}
          unionName={this.props.User.union ? this.props.User.union : ''}
          logOut={this.signOff}
        />

        <Switch>
          <Route path="/" component={CoursePortalMain} />
        </Switch>
        <ModalContainer />
      </>
    );
  }
}

function mapStateToProps(state: any, ownProps: any) {
  return {
    User: UserSelector.getUser()
  };
}

function mapDispatchToProps(dispatch: Dispatch<Action<any>>, ownProps: any) {
  return {
    logOut: () => {
      AuthHelper.LogOff();
    }
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/App.tsx